import { OrganisationDoc } from '../../../../../types';
import { isOverXDaysAgo } from '../../../../../utilities/validation';

type OrganisationDocMeta = Pick<
  OrganisationDoc,
  | 'hasOfficialLetterhead'
  | 'nameAndLogoVisible'
  | 'officiallySigned'
  | 'hasDate'
  | 'selectedTextBodyReq'
  | 'hasContactDetails'
  | 'dateOnLetter'
>;

const getHighlightedErrorSections = (doc: OrganisationDocMeta) => {
  const {
    hasOfficialLetterhead,
    nameAndLogoVisible,
    officiallySigned,
    hasDate,
    selectedTextBodyReq = [],
    hasContactDetails
  } = doc;

  // Are there any errors?
  // highlight the specific sections
  const hasOfficialLetterheadHighlight = hasOfficialLetterhead === false ? ['1.1'] : [];
  const nameAndLogoVisibleHighlight = nameAndLogoVisible === false ? ['1.2'] : [];
  const officiallySignedHighlight = officiallySigned === false ? ['1.3'] : [];
  const hasDateHighlight = hasDate === false ? ['2.1', '2.2'] : [];

  const dateOnLetterHighlight = hasDate === true && isOverXDaysAgo(doc.dateOnLetter, 31) ? ['2.2'] : [];
  const selectedTextBodyReqHighlight = [];
  if (!selectedTextBodyReq.includes('fullName')) {
    selectedTextBodyReqHighlight.push('3.1');
  }
  if (!selectedTextBodyReq.includes('orgName')) {
    selectedTextBodyReqHighlight.push('3.2');
  }
  if (!selectedTextBodyReq.includes('courseName')) {
    selectedTextBodyReqHighlight.push('3.3');
  }
  if (!selectedTextBodyReq.includes('contributionAmount')) {
    selectedTextBodyReqHighlight.push('3.4');
  }
  if (!selectedTextBodyReq.includes('periodCovered')) {
    selectedTextBodyReqHighlight.push('3.5');
  }
  const hasContactDetailsHighlight = hasContactDetails === false ? ['4.1'] : [];
  if (
    hasOfficialLetterheadHighlight.length ||
    nameAndLogoVisibleHighlight.length ||
    officiallySignedHighlight.length ||
    hasDateHighlight.length ||
    dateOnLetterHighlight.length ||
    selectedTextBodyReqHighlight.length ||
    hasContactDetailsHighlight.length
  ) {
    // unique values only AND
    // remove empty strings in array
    return [
      ...new Set(
        [
          ...hasOfficialLetterheadHighlight,
          ...nameAndLogoVisibleHighlight,
          ...officiallySignedHighlight,
          ...hasDateHighlight,
          ...dateOnLetterHighlight,
          ...selectedTextBodyReqHighlight,
          ...hasContactDetailsHighlight
        ].filter(Boolean)
      )
    ];
  }
  return [];
};

export default getHighlightedErrorSections;
